<template>
	<mgl-vector-source :source-id="id" :tiles="tiles">
		<!-- Layer components must be default-slot children of the source:
		     vue-maplibre-gl provides sourceId/sourceLayerRegistry to them
		     via the source component's provide scope. -->
		<slot />
	</mgl-vector-source>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { MglVectorSource } from "vue-maplibre-gl";
import { useSessionStore } from "@/store/session";

const props = defineProps<{
	id: string;
	mapName: string;
	params?: Record<string, string | number>;
}>();

const session = useSessionStore();

const tiles = computed<string[]>(() => {
	const base = session.urls?.tegola ?? "";
	const qs = new URLSearchParams();
	const params = props.params ?? {};
	for (const [key, value] of Object.entries(params)) {
		qs.set(key, String(value));
	}
	return [`${base}maps/${props.mapName}/{z}/{x}/{y}?${qs}`];
});
</script>
